import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/biblish/biblish/inaction/src/app/(appLayout)/inaction/viewPlay/[playId]/ClientPage.tsx");
